import * as React from "react"
import { classNames } from "../../../../../utils/classNames"

type Props = {
    label: string | React.ReactNode
    helpText?: string
    className?: string
    borderPosition?: "top" | "bottom"
    children: React.ReactNode
}
export const SettingRow = ({ label, helpText, className, borderPosition = "top", children }: Props) => {
    return (
        <div
            className={classNames(
                classes.wrap,
                borderPosition === "top" ? classes.borderTop : classes.borderBottom,
                className
            )}>
            <div className={classes.labelCol}>
                <div className={classes.label}>{label}</div>
                {helpText ? <div className={classes.desc}>{helpText}</div> : null}
            </div>
            <div>{children}</div>
        </div>
    )
}

const classes = {
    wrap: "mx-4 flex items-center border-gray-200 py-3",
    borderTop: "border-t mt-2",
    borderBottom: "border-b",
    labelCol: "flex-1",
    label: "text-14 text-black/80",
    desc: "-mt-px text-12 text-[#7E7E7E]",
}
